import { toast } from 'react-toastify';
import { toastResponse } from '../../../../helper components/Toast/Toast';

import Button from 'react-bootstrap/Button';
import { DataTable } from 'primereact/datatable';
import React, { useState, useEffect, useCallback } from 'react';
import { Column } from 'primereact/column';
import './employee.component.scss';
import { MultiSelect } from 'primereact/multiselect';
import { FilterMatchMode } from 'primereact/api';
import allImages from '../../../../assets/images/allImages';
import { InviteEmployee } from '../inviteEmployee/InviteEmployee';
import { EditEmployee } from '../editEmployee/EditEmployee';
import 'primeicons/primeicons.css';
// import { InputSwitch } from 'primereact/inputswitch';
import { useNavigate } from 'react-router-dom';
import { ConfirmationPopup } from '../../../Common/confirmationPopup/ConfirmationPopup';
// import { Checkbox } from 'primereact/checkbox';
import { useApolloClient, useQuery, useMutation } from '@apollo/client';
import {
  GetEnterpriseEmployeesByEnterpriseId,
  GetEnterpriseClientById,
} from '../../../../Queries/Queries';
import {GetEnterpriseEmployeesByEnterpriseIdV2} from '../../../../Queries/QueriesUpdated'
import { SendAppInviteByEmployeesId } from '../../../../Mutations/Mutations';
import { useSelector } from 'react-redux';
import { setLoaderFalse, setLoaderTrue } from '../../../../Redux/loaderSlice';
import { useDispatch } from 'react-redux';
import { isLogout } from '../../../../Redux/authSlice';
import { globalError } from '../../../../utils/global-error-handler';

export const EmployeeList = () => {
  /**
   * DECLARING STATES AND USEEFFECT
   */

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const client = useApolloClient();
  const authReducer = useSelector((state) => state.authReducer);

  const [employee, setEmployee] = useState([]);
  const [filteredEmployee, setFilteredEmployee] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  // const [rowClick, setRowClick] = useState(true);
  const [showEdit, setShowEdit] = useState(false);
  const [showInvite, setShowInvite] = useState(false);
  const [showConfirm, setConfirm] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  // const [checked, setChecked] = useState(true);
  //States for User status filter
  const [userStatusFilterOptions, setUserStatusFilterOptions] = useState([]);
  //States for App status filter
  const [appStatusFilterOptions, setAppStatusFilterOptions] = useState([]);

  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [confirmationFlag, setConfirmationFlag] = useState(false);

  const [selectedStatus, setSelectedStatus] = useState([]);
  const [enterpriseEmpStatus, setEnterpriseEmpStatus] = useState();
  // const [selectedCities, setSelectedCities] = useState(null);
  const [filters, setFilter] = useState({
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
  });

  //Fetch Employee list
  // const { refetch } = useQuery(
  //   GetEnterpriseEmployeesByEnterpriseIdV2,
  // );

  const groupedStatus = [
    {
      label: 'App Status',
      code: 'AS',
      items: appStatusFilterOptions,
    },
    {
      label: 'User Status',
      code: 'US',
      items: userStatusFilterOptions,
    },
  ];

  //Assign mutaions to variable
  const [fnSendEmailToSelectedEmployee] =
    useMutation(SendAppInviteByEmployeesId, {
      onCompleted: (data) => {
        toast.success(toastResponse('success', 'Invitation sent to the selected employees successfully...!'))
        window.location.href = '/enterprise/enterprise-admin/dashboard';
      },

      onError: ({ graphQLErrors }) => {
        toast.error(toastResponse('error', graphQLErrors[0].message));
      },
    });

  // console.log(groupedStatus)

  useEffect(() => {
    // This code will run when the employee state is updated.

    if (employee.length > 0) {
      setFilteredEmployee(employee);
      let userFilterData = employee
        .map((item) => item?.status)
        .reduce((acc, item) => {
          let index =
            acc.length > 0 ? acc.findIndex((val) => val.label === item) : -1;
          index === -1
            ? acc.push({ label: item, value: item })
            : (acc[index].value = item);
          return acc;
        }, []);
      setUserStatusFilterOptions(userFilterData);

      let appFilterData = employee
        .map((item) => item?.appStatus)
        .reduce((acc, item) => {
          let index =
            acc.length > 0 ? acc.findIndex((val) => val.label === item) : -1;
          index === -1
            ? acc.push({ label: item, value: item })
            : (acc[index].value = item);
          return acc;
        }, []);
      setAppStatusFilterOptions(appFilterData);
    }
  }, [employee]);

  // const fetchUserStatusData = useCallback(async () => {
  //   //Animated Loader true
  //   dispatch(setLoaderTrue());
  //   try {
  //     const { data } = await client.query({
  //       query: GetEnterpriseClientById,
  //       variables: {
  //         getEnterpriseClientByIdId: authReducer.enterpriseClientID,
  //       },
  //     });

  //     setEnterpriseEmpStatus(
  //       data?.getEnterpriseClientById?.enterpriseEmployeeStats,
  //     );

  //     //Animated Loader false
  //     dispatch(setLoaderFalse());
  //   } catch (error) {
  //     //Animated Loader false
  //     dispatch(setLoaderFalse());

  //     console.error('Error in fetching enterprise list', error);
  //   }
  // },[authReducer.enterpriseClientID, client, dispatch]);

  const fetchEnterpriseEmployeesByEnterpriseId = useCallback(async () => {
    // refetch();

    //Animated Loader true
    dispatch(setLoaderTrue());
    try {
      const { data } = await client.query({
        query: GetEnterpriseEmployeesByEnterpriseIdV2,
        // variables: {
        //   getEnterpriseEmployeesByEnterpriseIdId: authReducer.enterpriseID,
        // },
        variables: {
          input: {
            filter: {
              conditions: [
                {
                  operator: "DOES_NOT_CONTAIN",
                  property: "EMAIL",
                  value: "#"
                }
              ]
            },
            "limit": 400,
            "offset": 0,
            "sort": "DESC"
          },
          // "clientId": authReducer.enterpriseID
        }
      });

      if (data) {
        // setEmployee(data?.getEnterpriseEmployeesByEnterpriseId);
        // setFilteredEmployee(data?.getEnterpriseEmployeesByEnterpriseId);

        setEmployee(
          data?.getEmployees.employees.map((item) => ({
            ...item,
            appStatus: item.appStatus !== null ? item.appStatus : 'NA',
            phoneNumber: item?.phones?.length ? item.phones[0].phoneNumber : 'NA',
            employeeId: item.externalEmployeeId ?? 'NA',
          })),
        );

        setEnterpriseEmpStatus({
          active: data?.getEmployeeStats?.active ?? 0,
          registered: data?.getEmployeeStats?.registered ?? 0,
          total: data?.getEmployeeStats?.total ?? 0,
          invited: data?.getEmployeeStats?.invited ?? 0
        });

        // setFilteredEmployee(data?.getEnterpriseEmployeesByEnterpriseId.map(item => ({
        //     ...item,
        //     appStatus: item.appStatus !== null ? item.appStatus : 'NA'
        // })));

        // Filter data based on the initial selectedStatus
        // const filteredData = data?.getEnterpriseEmployeesByEnterpriseId.filter(item => {
        //     if(item.status || item.appStatus)
        //     return selectedStatus.includes(item.status) || selectedStatus.includes(item.appStatus);
        // });

        // setFilteredEmployee(filteredData);
      }

      //Animated Loader false
      dispatch(setLoaderFalse());
    } catch (error) {
      console.log('error', error);
      // if (error.networkError.statusCode) {
      //   const errorDetails = globalError(error.networkError.statusCode);
      //   toast.error(toastResponse('error', errorDetails.message));

      //   dispatch(isLogout());
      //   // navigate("/user/login");
        
      //   setTimeout(() => {
      //     window.location.href = '/user/login';
      //   }, 500);
      // }
      //Animated Loader false
      dispatch(setLoaderFalse());

      console.error('Error in fetching enterprise list', error);
    }
  }, [client, dispatch]);

  // useEffect(() => {
  //   fetchUserStatusData();
  //   fetchEnterpriseEmployeesByEnterpriseId();
  // }, [fetchUserStatusData, fetchEnterpriseEmployeesByEnterpriseId]);

  useEffect(() => {
    fetchEnterpriseEmployeesByEnterpriseId();
  }, [fetchEnterpriseEmployeesByEnterpriseId]);

  const userStatusBody = (rowData) => {
    return (
      <>
        <div className="action-btn">
          <Button
            className="btn-hover-color  py-1"
            style={{
              background: '#03c4de',
              borderRadius: '6px',
              padding: '2rem',
            }}
            onClick={() => {
              setSelectedRow(rowData);
              setShowEdit(true);
            }}
          >
            Edit
          </Button>
          {rowData.userStatus === 'ACTIVE' ? (
            <Button
              className="btn-hover-color  mx-1 py-1"
              style={{
                background: '#03c4de',
                borderRadius: '6px',
                padding: '2rem',
              }}
              onClick={() => {
                setSelectedRow(rowData);
                setShowInvite(true);
              }}
            >
              Invite
            </Button>
          ) : (
            ''
          )}
        </div>
        <div className="columnData py-1">{rowData.status}</div>
      </>
    );
  };

  const employeeNameBody = (rowData) => {
    const fullName = rowData.firstName.concat(' ', rowData.lastName);
    return (
      <>
        <div>{fullName}</div>
      </>
    );
  };

  // const activeInactiveEmployee = (event) => {
  //   setConfirm(true);
  // };

  const sendInviteToSelecledEmp = () => {
    // try {
    //   let temp = [];
    //   selectedEmployee.forEach((item) => {
    //     temp.push(item.id);
    //   });

    //   fnSendEmailToSelectedEmployee({
    //     variables: { enterpriseEmployeeIds: temp },
    //   });
    // } catch (error) {
    //   console.log(error);
    // }
    toast.success(toastResponse('success', 'App Invite Mutation Is Not Available..!'))
  };

  const handleFilterChange = (e) => {
    setSelectedStatus(e.value);
    // console.log(e.value);
    if (e.value.length === 0) {
      setFilteredEmployee(employee);
    } else {
      let options = e.value.map((item) => item);

      const filteredEmployee = employee.filter((item) => {
        // Check if any of the selected filters match either appStatus or userStatus
        return options.some(
          (filter) => item.appStatus === filter || item.status === filter,
        );
      });

      setFilteredEmployee(filteredEmployee);
    }
  };
  // const handleCheckboxChange = (rowData) => {
  //   const updatedData = [...filteredEmployee];
  //   const itemToUpdate = updatedData.find((item) => item.id === rowData.id);

  //   if (itemToUpdate) {
  //     itemToUpdate.selected = !itemToUpdate.selected;
  //     setFilteredEmployee(updatedData);
  //   }
  // };

  const isCellSelectable = (event) =>
    event.data.userStatus === 'Inactive' ? false : true;

  return (
    <>
      <div className="row pt-4 pb-4">
        <div className="col-md-8">
          <div className="totalEnterpriseBlock me-7">
            <div className="blockTitle fw-bolder">Active Employees</div>
            <div className="blockNumber">
              {enterpriseEmpStatus ? enterpriseEmpStatus.active : 'NA'}
            </div>
          </div>

          <div className="totalEnterpriseBlock" style={{ margin: '0 auto' }}>
            <div className="blockTitle fw-bolder">App Invites Sent</div>
            <div className="blockNumber">
              {enterpriseEmpStatus ? enterpriseEmpStatus.invited : 'NA'}
            </div>
          </div>
        </div>

        <div className="col-md-4 text-center" style={{display: authReducer.role === 'ENTERPRISE_ADMIN' || authReducer.role === 'BOND_ADMIN' ? 'block' : 'none'}}>
          <div className="btn-large-block theme btn-primary-lg">
            <button
              className=" btn text-white fw-bolder w-100 h-100 p-0"
              onClick={() =>
                navigate('/enterprise/enterprise-admin/upload-employee')
              }
            >
              +Upload Employees
            </button>
          </div>
        </div>
      </div>

      <div
        className="row m-0 customTable border"
        style={{ display: filteredEmployee.length > 0 ? 'block' : 'none' }}
      >
        <div className="col-md-12">
          <div className="row customTable mainheader">
            <div className="col-md-6 ps-2 pt-1">
              <div className="customTable title">
                <label>Employee List</label>
              </div>
            </div>
            <div className="col-md-3">
              <div className="search-field position-relative">
                <div className="customTable static-search-mg">
                  <img
                    src={allImages.search}
                    className="img-fluid"
                    style={{ height: '1.2rem' }}
                    alt="search_icon"
                  />
                </div>
                <input
                  type="text"
                  placeholder="Search"
                  className="form-control customTable custom-input-field"
                  value={globalFilterValue}
                  onChange={(e) => {
                    setFilter((filters) => ({
                      ...filters,
                      global: {
                        ...filters['global'],
                        value: e?.target?.value.trim(),
                      },
                    }));
                    setGlobalFilterValue(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-xl-3 col-md-3">
              {/* <MultiSelect className="custom-multiselect" value={selectedUserStatus} options={userStatusFilterOptions} onChange={(e) => handleFilterChange(e)} optionLabel="label" style={{ width: "90%" }}
                                placeholder={<><i className="pi pi-filter" style={{ fontSize: '1.1rem' }}></i><span className="ps-4">Filter</span></>}
                                filter /> */}

              <MultiSelect
                className="custom-multiselect"
                // value={Array.isArray(selectedUserStatus)?selectedUserStatus.join(', '):''}
                value={selectedStatus}
                options={groupedStatus}
                optionLabel="label"
                filter
                optionGroupLabel="label"
                optionGroupChildren="items"
                onChange={(e) => handleFilterChange(e)}
                placeholder={
                  (
                  <>
                    <i
                      className="pi pi-filter"
                      style={{ fontSize: '1.1rem' }}
                    />
                    <span style={{ paddingLeft: '0.5rem' }}>Filter</span>
                  </>
                  )
                }
                display="chip"
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </div>
        <div
          className="col-md-12 py-1 px-0 "
          style={{
            background: '#f8f9fa',
            display: selectedEmployee.length > 0 ? 'block' : 'none',
          }}
        >
          <div className="row py-1">
            <div className="col-md-2">
              <div className="mx-3 ps-2 align-middle">
                {selectedEmployee.length} user selected
              </div>
            </div>
            {/* <div className='col-md-2'>
                                    Active<InputSwitch className="mx-2 align-middle" checked={checked} onChange={(e) => { setConfirmationFlag(false); activeInactiveEmployee(e.value); setChecked(e.value) }} />
                                </div> */}
            <div className="col-md-2">
              <span className="align-middle">Send invite</span>
              <img
                src={allImages.invite}
                className="img-fluid mx-2 align-middle cursor-pointer"
                onClick={(e) => {
                  setConfirmationFlag(true);
                  setConfirm(true);
                }}
                alt="send_invite_img"
              />
            </div>
            <div className="col-md-6" />
          </div>
        </div>
        <div className="col-md-12 p-0">
          <DataTable
            value={filteredEmployee}
            dataKey="id"
            rowHover="true"
            removableSort
            className="customTable tableHeight"
            // className={selectedEmployee.length > 0 ? 'hide-header' : ''}
            globalFilterFields={[
              'firstName',
              'lastName',
              'employeeId',
              'email',
              'phoneNumber',
              'status',
            ]}
            filters={filters}
            emptyMessage={
              (
              <h5 className="text-center h-100  pt-4 fw-bolder w-100">
                There is no data to display at the moment.
              </h5>
              )
            }
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
            // selectionMode={rowClick ? null : 'Checkbox'}
            selection={selectedEmployee}
            onSelectionChange={(e) => {
              setSelectedEmployee(e.value);
            }}
            scrollable
            scrollHeight="flex"
            resizableColumns="true"
            isDataSelectable={isCellSelectable}
          >
            <Column
              selectionMode="multiple"
              headerClassName="multiselectHeader"
              style={{ maxWidth: '4%' }}
            />
            <Column
              field="employeeId"
              header="Employee ID"
              sortable
              style={{ maxWidth: '40%' }}
            />
            <Column
              field="name"
              header="Name"
              body={employeeNameBody}
              sortable
              style={{ maxWidth: '40%' }}
            />
            <Column
              field="email"
              header="Email"
              sortable
              style={{ maxWidth: '80%' }}
            />
            <Column
              field="phoneNumber"
              header="Mobile Number"
              sortable
              style={{ maxWidth: '80%' }}
            />
            <Column
              field="appStatus"
              header="App Status"
              sortable
              style={{ maxWidth: '80%' }}
            />
            <Column
              field="status"
              header="User Status"
              style={{ width: '18%' }}
              sortable
              body={userStatusBody}
            />
          </DataTable>
        </div>
      </div>

      <div
        className="row"
        style={{ display: filteredEmployee.length === 0 ? 'block' : 'none' }}
      >
        <h2>Please upload the employee list....</h2>
      </div>

      <InviteEmployee
        showInvite={showInvite}
        onInviteHide={() => setShowInvite(false)}
        selectedRow={selectedRow}
      />
      <EditEmployee
        showEdit={showEdit}
        onEditHide={() => setShowEdit(false)}
        selectedRow={selectedRow}
        refetch={() =>
          (window.location.href =
            '/enterprise/enterprise-admin/dashboard')
        }
      />
      <ConfirmationPopup
        showConfirm={showConfirm}
        onConfirmHide={() => setConfirm(false)}
        headerText={
          // !confirmationFlag
          //   ? `Employee ${!checked ? 'Inactive' : 'Active'} Confirmation`
          //   : 'Send Invitation Confirmation'
          'Send Invitation Confirmation'
        }
        // status={checked}
        status={''}
        modalBody={
          // !confirmationFlag
          //   ? `Are you certain about marking these employees as ${!checked ? "'inactive'" : "'active'"} Once they are marked as inactive, they will no longer have access to the app.`
          //   : 'Are you sure you want to send invite to selected employees?'
          'Are you sure you want to send invite to selected employees?'
        }
        otherBtnText={
          // !confirmationFlag
          //   ? `Mark as  ${!checked ? 'Inactive' : 'Active'}`
          //   : 'Send Invitation'
          'Send Invitation'
        }
        toggle={confirmationFlag}
        // activeToggle={checked}
        activeToggle={''}
        type={!confirmationFlag ? 'empActive' : 'empInvite'}
        onConfirmStatus={() => sendInviteToSelecledEmp()}
      />
    </>
  );
};
